export enum widthEnum{
  sm = '120px',
  md = '150px',
  mdLg = '200px',
  lg = '300px',
}